import React, {Component} from 'react';
import {Pie, Cell, PieChart, Legend,ResponsiveContainer, Tooltip} from 'recharts'

class ChannelEffectiveness extends Component{

  constructor(props){
    super(props);
    this.state={data:[
        {type:"Abogado", quantity:505},
        {type:"Gestor", quantity:350},
        {type:"Contact center", quantity:800},
        {type:"Sepomex", quantity:174},
      ]}
  }


  render(){

    const colors=[
      "#222",
      "#777",
      "#c79b6e",
      "#3a5175"
    ]

    return(
      <ResponsiveContainer>
        <PieChart width={250} height={250} >
          <Tooltip/>
          <Legend/>
          <Pie data={this.state.data} dataKey={"quantity"} nameKey={"type"} innerRadius={50} outherRadius={55} label>
            {
              this.state.data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colors[index]}/>
              ))
            }
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    );
  }

}

export default ChannelEffectiveness;



// WEBPACK FOOTER //
// ./src/charts/channelEffectiveness.js